import React, { useState, useEffect } from "react";
import Loading from "../../shared/loading";
import { useAuthContext } from "../../context/authContext";
import { isAdmin } from "../../helpers/role";
import { Button } from "../../shared/button";
import { Chat, ChatMessage, ChatService } from "../../APIService/ChatService";
import { Link, useParams } from "react-router-dom";
import { useSnackbar } from "notistack";
import { ErrorMessage, Field, Form, Formik, FormikHelpers } from "formik";
import * as Yup from "yup";

export function OneChat() {
  const { enqueueSnackbar } = useSnackbar();
  const [messages, setMessages] = useState<ChatMessage[]>([]);
  const [loading, setLoading] = useState(true);
  const { authInfo } = useAuthContext();
  const chatId = Number(useParams().id);
  const [update, setUpdate] = useState(false);
  const [chatName, setChatName] = useState("");

  useEffect(() => {
    ChatService.getChatInfo(chatId)
      .then((chat) => {
        setChatName(chat.name);
        ChatService.getChatMessages(chatId)
          .then((data) => {
            setMessages(data);
            setLoading(false);
          })
          .catch(() => {
            enqueueSnackbar(`Упс!`, {
              variant: "error",
              anchorOrigin: { horizontal: "right", vertical: "top" },
            });
            setLoading(false);
          });
      })
      .catch(() => {
        enqueueSnackbar(`Чат не найден`, {
          variant: "error",
          anchorOrigin: { horizontal: "right", vertical: "top" },
        });
        setLoading(false);
      });
  }, [update]);

  return (
    <div className="chatPage">
      <h3>{chatName}</h3>
      {loading ? (
        <Loading />
      ) : messages.length > 0 ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 10,
            padding: 20,
          }}
        >
          {messages.map((m) => {
            // format m.date to day.month hh:mm
            const date = new Date(m.date);
            const formattedDate = `${date.getDate().toString().padStart(2, "0")}.${(date.getMonth() + 1).toString().padStart(2, "0")} ${date.getHours().toString().padStart(2, "0")}:${date.getMinutes().toString().padStart(2, "0")}`;
            return (
              <div key={m.id}>
                <span className="chatMessageHeader">
                  {m.sysName} ({formattedDate}):
                </span>
                <br />
                {m.text}
              </div>
            );
          })}
        </div>
      ) : (
        <p>Нет сообщений</p>
      )}
      <Formik
        initialValues={{ message: "" }}
        validationSchema={Yup.object({
          message: Yup.string().required("Обязательное поле"),
        })}
        onSubmit={async (
          values: { message: string },
          actions: FormikHelpers<{ message: string }>,
        ) => {
          console.log({ values, actions });
          await ChatService.postMessage(chatId, values.message);
          actions.resetForm();
          setUpdate(!update);
        }}
      >
        {({ isSubmitting }) => (
          <Form className="EditFormSelfPayment">
            <Field id="message" type="text" name="message" />
            <button
              className={"SharedButton"}
              type="submit"
              disabled={isSubmitting}
            >
              Отправить
            </button>
          </Form>
        )}
      </Formik>
    </div>
  );
}

export default OneChat;
